import Vue from 'vue'
import Vuex from 'vuex'
import common from './modules/common'
import transData from './modules/transData'
import hqData from './modules/hqData'
import mydata from './modules/mydata'
import uoa from './modules/uoa'
import mData from './modules/mData'
import klinecache from './modules/klinecache'

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    common,
    transData,
    hqData,
    mydata,
    uoa,
    mData,
    klinecache
  },
  strict: debug
})
